/* amphr-video-controls.js — the theme's own controls for hosted video.
 *
 * The markup ships with the control bar hidden and no `controls` attribute on
 * the <video>; this file reveals the bar and wires it. A visitor without
 * JavaScript therefore keeps a playable clip with the browser's own controls,
 * which is why the reveal happens here rather than in CSS.
 *
 * Players are bound on demand: lightbox slides exist before the overlay opens,
 * and grids arrive over AJAX, so there is no single moment at which every
 * player is present.
 */
(function () {
  'use strict';

  function clock(seconds) {
    if (!isFinite(seconds) || seconds < 0) seconds = 0;
    var m = Math.floor(seconds / 60);
    var s = Math.floor(seconds % 60);
    return m + ':' + (s < 10 ? '0' : '') + s;
  }

  function bind(player) {
    if (player.dataset.amphrBound) return;
    var video = player.querySelector('video');
    if (!video) return;
    player.dataset.amphrBound = '1';

    var bar = player.querySelector('[data-vctl]');
    var playBtn = player.querySelector('[data-vplay]');
    var bigPlay = player.querySelector('[data-vplay-big]');
    var muteBtn = player.querySelector('[data-vmute]');
    var seek = player.querySelector('[data-vseek]');
    var timeEl = player.querySelector('[data-vtime]');
    var durationEl = player.querySelector('[data-vduration]');

    video.removeAttribute('controls');
    bar.hidden = false;

    var scrubbing = false;

    function label(btn, text) {
      btn.setAttribute('aria-label', text);
    }

    function paintPlayState() {
      player.classList.toggle('is-playing', !video.paused && !video.ended);
      var text = video.paused ? playBtn.dataset.playLabel : playBtn.dataset.pauseLabel;
      label(playBtn, text);
      label(bigPlay, playBtn.dataset.playLabel);
    }

    function paintMuteState() {
      player.classList.toggle('is-muted', video.muted || video.volume === 0);
      label(muteBtn, video.muted ? muteBtn.dataset.unmuteLabel : muteBtn.dataset.muteLabel);
    }

    function paintTime() {
      timeEl.textContent = clock(video.currentTime);
      durationEl.textContent = clock(video.duration);
      if (!scrubbing && video.duration) {
        seek.value = String(Math.round((video.currentTime / video.duration) * 1000));
      }
    }

    function toggle() {
      if (video.paused) {
        var started = video.play();
        /* Rejects when the browser declines the request; the poster and this
           bar stay usable, so there is nothing to report. */
        if (started && started.catch) started.catch(function () {});
      } else {
        video.pause();
      }
    }

    playBtn.addEventListener('click', toggle);
    bigPlay.addEventListener('click', toggle);
    video.addEventListener('click', toggle);

    muteBtn.addEventListener('click', function () {
      video.muted = !video.muted;
      paintMuteState();
    });

    seek.addEventListener('input', function () {
      scrubbing = true;
      if (video.duration) video.currentTime = (seek.value / 1000) * video.duration;
    });
    seek.addEventListener('change', function () {
      scrubbing = false;
    });

    /* The lightbox pages slides with the arrow keys. On the scrubber those keys
       mean "step through this clip", so they must not reach it. */
    seek.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') e.stopPropagation();
    });

    ['play', 'pause', 'ended'].forEach(function (type) {
      video.addEventListener(type, paintPlayState);
    });
    ['timeupdate', 'loadedmetadata', 'durationchange'].forEach(function (type) {
      video.addEventListener(type, paintTime);
    });
    video.addEventListener('volumechange', paintMuteState);

    paintPlayState();
    paintMuteState();
    paintTime();
  }

  function bindAll(root) {
    (root || document).querySelectorAll('[data-amphr-video]').forEach(bind);
  }

  window.amphrBindVideoPlayers = bindAll;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bindAll(); });
  } else {
    bindAll();
  }

  document.addEventListener('shopify:section:load', function (e) { bindAll(e.target); });
})();
